module.exports = __webpack_public_path__ + "img/billmenu1.dfd6d095.png";